import { useState } from 'react';

import { useCompanies } from '../api';

import { Company } from '../types';

export const options = [
  { value: 'ALL', label: 'All' },
  // ! default status to show! - @2025/05/20
  { value: 'ACTIVE', label: 'Active' },
  { value: 'NEW', label: 'New' },
  { value: 'DELETED', label: 'Deleted' },
];

export type SelectValue = { value: string; label: string };

export const useCompanyList = () => {
  const [selectedOption, setSelectedOption] = useState<SelectValue>(options[1]);
  const { data: companies } = useCompanies();

  const companyStateFilter = ({ status }: Company) => {
    // check selected company state:
    switch (selectedOption.value) {
      case 'ALL':
        return true;
      case 'ACTIVE':
        return status === 'ACTIVE';
      case 'NEW':
        return status == null;
      case 'DELETED':
        return status === 'DELETED';
      default:
        return false;
    }
  };
  const filteredCompanies: Company[] | undefined =
    companies?.filter(companyStateFilter);

  return {
    companiesByStatus: filteredCompanies,
    selectedOption,
    setSelectedOption,
  };
};
